// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"u--z"};